import fetch from "lib/fetch";
import type { BlockUserInterface } from "types/blockUser";

type BlockUserResponse = { data: BlockUserInterface };

export const createBlockUserRequest = (data: HashMap<unknown>) =>
    fetch.post<BlockUserResponse>("block_user", data);

export const getBlockUserRequest = (blockedUserId: string) =>
    fetch.get<BlockUserResponse>(`block_user/${blockedUserId}`);

export const deleteBlockUserRequest = (blockedUserId: string) =>
    fetch.delete<BlockUserResponse>(`block_user/${blockedUserId}`);
